// extracted by mini-css-extract-plugin
export default {"root":"ApprovalSidebarPage_root__Uh7-K","pageActions":"ApprovalSidebarPage_pageActions__e+Q3o"};